export const messages = {
  en: {
    returnStorehouseApplyManage: {
      title: 'Return Items',
      back: 'Back',
      selectItems: 'Select Items',
      itemId: 'Item ID',
      itemType: 'Item Type',
      itemName: 'Item Name',
      itemSpec: 'Item Specification',
      stock: 'Stock',
      miniStock: 'Minimum Stock',
      targetWarehouse: 'Target Warehouse',
      returnQuantity: 'Return Quantity',
      operation: 'Operation',
      cancelReturn: 'Cancel Return',
      returnAll: 'Return All',
      returnDescription: 'Return Description',
      requiredDescription: 'Required, please fill in the return description',
      submit: 'Submit',
      descriptionRequired: 'Return description is required',
      selectItemsRequired: 'Please select items',
      quantityRequired: 'Please fill in the quantity',
      targetWarehouseRequired: 'Please select target warehouse',
      stockNotEnough: ' stock is not enough',
      returnSuccess: 'Return successfully',
      returnFailed: 'Return failed',
      requiredSelect: 'Required, please select target warehouse'
    },
    chooseResourceStaff: {
      title: 'Select Items',
      selectItemType: 'Please select item type',
      selectSubType: 'Please select sub type',
      inputItemName: 'Input item name',
      itemType: 'Item Type',
      itemName: 'Item Name',
      itemCode: 'Item Code',
      isFixed: 'Is Fixed',
      stock: 'Stock',
      miniStock: 'Minimum Stock',
      selectItemsRequired: 'Please select items'
    }
  },
  zh: {
    returnStorehouseApplyManage: {
      title: '退还物品',
      back: '返回',
      selectItems: '选择物品',
      itemId: '物品ID',
      itemType: '物品类型',
      itemName: '物品名称',
      itemSpec: '物品规格',
      stock: '库存',
      miniStock: '最小计量总数',
      targetWarehouse: '目标仓库',
      returnQuantity: '退还数量',
      operation: '操作',
      cancelReturn: '取消退还',
      returnAll: '全部退还',
      returnDescription: '退还说明',
      requiredDescription: '必填，请填写退还说明',
      submit: '提交',
      descriptionRequired: '退还说明不能为空',
      selectItemsRequired: '请选择物品',
      quantityRequired: '请填写数量',
      targetWarehouseRequired: '请选择目标仓库',
      stockNotEnough: '库存不足',
      returnSuccess: '退还成功',
      returnFailed: '退还失败',
      requiredSelect: '必填，请选择目标仓库'
    },
    chooseResourceStaff: {
      title: '选择物品管理',
      selectItemType: '请选择物品类型',
      selectSubType: '请选择二级分类',
      inputItemName: '输入物品管理名称',
      itemType: '物品类型',
      itemName: '物品名称',
      itemCode: '物品编码',
      isFixed: '是否是固定物品',
      stock: '物品库存',
      miniStock: '最小计量总数',
selectItemsRequired: '请选择需要转赠的物品'
    }
  },
  'zh-TW': {
    returnStorehouseApplyManage: {
      title: '退還物品',
      back: '返回',
      selectItems: '選擇物品',
      itemId: '物品ID',
      itemType: '物品類型',
      itemName: '物品名稱',
      itemSpec: '物品規格',
      stock: '庫存',
      miniStock: '最小計量總數',
      targetWarehouse: '目標倉庫',
      returnQuantity: '退還數量',
      operation: '操作',
      cancelReturn: '取消退還',
      returnAll: '全部退還',
      returnDescription: '退還說明',
      requiredDescription: '必填，請填寫退還說明',
      submit: '提交',
      descriptionRequired: '退還說明不能為空',
      selectItemsRequired: '請選擇物品',
      quantityRequired: '請填寫數量',
      targetWarehouseRequired: '請選擇目標倉庫',
      stockNotEnough: '庫存不足',
      returnSuccess: '退還成功',
      returnFailed: '退還失敗',
      requiredSelect: '必填，請選擇目標倉庫'
    },
    chooseResourceStaff: {
      title: '選擇物品管理',
      selectItemType: '請選擇物品類型',
      selectSubType: '請選擇二級分類',
      inputItemName: '輸入物品管理名稱',
      itemType: '物品類型',
      itemName: '物品名稱',
      itemCode: '物品編碼',
      isFixed: '是否是固定物品',
      stock: '物品庫存',
      miniStock: '最小計量總數',
      selectItemsRequired: '請選擇需要轉贈的物品'
    }
  }
}